import { DataGridLocaleTextColumn } from '@app/components/atoms/data-grid-locale-text-column'
import { CreateEntityModalButton } from '@app/components/createEntityModalButton'
import { SocialLinkForm } from '@app/components/forms/social-link-form'
import { UDDropdown } from '@app/components/uddropdown'
import { Binding } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import {
	DataGrid,
	DataGridActionColumn,
	DataGridLoader,
	DataGridPagination,
	DataGridQueryFilter,
	DataGridTable,
	DataGridToolbar,
} from '@app/lib/datagrid'
import { Slots } from '@app/lib/layout'

export default () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Social links</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<Slots.Actions>
							<CreateEntityModalButton entityName="SocialLink" buttonLabel="Create">
								<SocialLinkForm />
							</CreateEntityModalButton>
						</Slots.Actions>
						<DataGrid entities="SocialLink">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridLocaleTextColumn field="title" header="Title" />
									<DataGridActionColumn>
										<UDDropdown editForm={<SocialLinkForm />} />
									</DataGridActionColumn>
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}
